import { createContext } from 'react'

// @ts-ignore
export const TravelIdContext = createContext<number>(undefined)
export const StepperStepCountContext = createContext<number>(0)
export const BookingStepContext = createContext<number>(0)
export const PrivacyPolicyPageUrlContext = createContext<string>('/')
export const GtcPageUrlContext = createContext<string>('/')
